import { ServiceOrderNoteType, useRepositoryMutation } from '@mews-commander/data-access';
import { lt, showSuccessAlert } from '@mews/framework';
import { CompactedNote, NotesFormValues } from './types';
import { expandCombinedNotes } from './utils';

export const useUpdateNotes = (reservationIds: string[], onSuccess: () => void) => {
    const addNoteMutation = useRepositoryMutation('reservations', 'addNotes', {
        transformParams: (noteText: string) => ({
            reservationIds,
            text: noteText,
            type: ServiceOrderNoteType.General,
        }),
    });

    const updateNotesMutation = useRepositoryMutation('reservations', 'updateNotes', {
        transformParams: (notes: CompactedNote[]) => ({
            reservationIds,
            serviceOrderNotes: expandCombinedNotes(notes),
        }),
    });

    const updateNotes = async (formValues: NotesFormValues) => {
        try {
            const promises = [updateNotesMutation.mutateAsync(formValues.notes)];

            if (formValues.noteText) {
                promises.push(addNoteMutation.mutateAsync(formValues.noteText));
            }

            await Promise.all(promises);

            showSuccessAlert({ description: lt('NotesChangedSuccessMessage') });
            onSuccess();
            // eslint-disable-next-line @mews/no-empty-catch
        } catch (error) {
            // Error is already handled in mutations
        }
    };

    return { updateNotes, isLoading: updateNotesMutation.isPending || addNoteMutation.isPending };
};
